module.exports = __webpack_public_path__ + "8052ab607038de9870611fcf1c1cfec5.png";